export default __webpack_public_path__ + "static/media/Guarantee-icon-Blue.94efce0e.png";